import type { Playlist, Song } from '../../interfaces/types';
import { getAlbumPath, getPublicationPath } from '../../utils/getPublicPath';

export enum PublicationsTypesEnum {
  CERTIFICATION = 'CERTIFICATION',
}

/* ---------------- HackerRank Certifications ---------------- */
const HACKERRANK_SQL: Song = {
  name: 'SQL',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2024',
  description:
    'This certification demonstrates a strong understanding of SQL fundamentals, including joins, subqueries, aggregation, and database schema design — key for backend and data engineering work.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/21462ca28800',
  skills: [],
};

const HACKERRANK_JAVA: Song = {
  name: 'JAVA',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2024',
  description:
    'This certification validates a solid grasp of Java programming — covering object-oriented principles, data structures, exception handling, and efficient coding patterns in Java.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/bce0d7f028b8',
  skills: [],
};

const HACKERRANK_PROBLEM_SOLVING: Song = {
  name: 'PROBLEM_SOLVING',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2024',
  description:
    'The Problem Solving certification focuses on algorithmic and logical thinking — testing your ability to solve complex computational problems using optimal approaches and data structures.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/29bfb51633bb',
  skills: [],
};

const HACKERRANK_REACT: Song = {
  name: 'REACT',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2025',
  description:
    'This certification verifies knowledge of React fundamentals, hooks, state management, component design, and building responsive, maintainable frontend applications.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/88ca77c2d8ae',
  skills: [],
};

const HACKERRANK_JAVASCRIPT: Song = {
  name: 'JAVASCRIPT',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2024',
  description:
    'The JavaScript certification covers advanced JS concepts — including ES6+ syntax, asynchronous programming, DOM manipulation, and debugging for full-stack or frontend development.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/70511f0fd74e',
  skills: [],
};

const HACKERRANK_CSS: Song = {
  name: 'CSS',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2025',
  description:
    'This certification focuses on mastering modern CSS — including flexbox, grid layouts, responsive design, and styling animations to create visually engaging and user-friendly interfaces.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/70511f0fd74e',
  skills: [],
};

const HACKERRANK_SOFTWARE_ENGINEER: Song = {
  name: 'SOFTWARE_ENGINEER',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2025',
  description:
    'This certification showcases full-stack software engineering skills — integrating design principles, backend logic, database handling, APIs, and testing methodologies in modern applications.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/e2096e1fa97a',
  skills: [],
};

const HACKERRANK_SOFTWARE_ENGINEER_INTERN: Song = {
  name: 'SOFTWARE_ENGINEER_INTERN',
  artist: 'HackerRank',
  types: [PublicationsTypesEnum.CERTIFICATION],
  length: '2025',
  description:
    'Awarded for completing a software engineer internship challenge — demonstrating strong applied programming skills, collaborative project development, and problem-solving in real-world environments.',
  imageUrl: getPublicationPath('certificates/logo.png'),
  link: 'https://www.hackerrank.com/profile/mahetabshaikh201',
  certificate: 'https://www.hackerrank.com/certificates/83b8cbff976e',
  skills: [],
};

/* ---------------- Playlist Export ---------------- */
export const Publications: Playlist = {
  name: 'Certifications',
  description:
    'A verified collection of HackerRank certifications demonstrating technical excellence across web development, software engineering, and problem-solving domains.',
  songs: [
    HACKERRANK_SOFTWARE_ENGINEER,
    HACKERRANK_SOFTWARE_ENGINEER_INTERN,
    HACKERRANK_JAVASCRIPT,
    HACKERRANK_REACT,
    HACKERRANK_CSS,
    HACKERRANK_PROBLEM_SOLVING,
    HACKERRANK_JAVA,
    HACKERRANK_SQL,
  ],
  color: '#3d5255',
  filters: [PublicationsTypesEnum.CERTIFICATION],
  getImage(lang) {
    return getAlbumPath('Publications-cover', lang, 'png');
  },
};
